import React from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import ClaimableAuthenticator from "../../components/Shared/ClaimableAuthenticator";
import styles from "./queryAuthGate.module.scss";

interface QueryAuthGateProps {
  children: React.ReactNode;
}

const QueryAuthGate: React.FC<QueryAuthGateProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const newUser =
    searchParams.get("newUser")?.toLowerCase() === "true" || false;
  const email = searchParams.get("email");
  const { user, authStatus } = useAuthenticator();
  const isAuthenticated = Boolean(user) && authStatus === "authenticated";
  let formFields;

  if (newUser) {
    formFields = email
      ? {
          signUp: {
            email: {
              defaultValue: email,
              isRequired: true,
              isReadOnly: true,
              className: styles.authenticatorEmailField,
            },
          },
        }
      : undefined;
  } else if (!newUser) {
    formFields = email
      ? {
          signIn: {
            username: {
              defaultValue: email,
              isRequired: true,
              isReadOnly: true,
              className: styles.authenticatorEmailField,
            },
          },
        }
      : undefined;
  }

  if (isAuthenticated) {
    return (
      <>
        <ClaimableAuthenticator
          defaultTab={newUser ? "signUp" : "signIn"}
          formFields={formFields}
        />
        {children}
      </>
    );
  }

  return (
    <ClaimableAuthenticator
      defaultTab={newUser ? "signUp" : "signIn"}
      formFields={formFields}
    />
  );
};

export default QueryAuthGate;
